import { call, put, takeEvery } from 'redux-saga/effects';
import { checkReferenceBike } from '../../requests/get_reference_bike_request';
import { getReferenceBikeRequestSuccess, getReferenceBikeRequestFailure } from '../actions/get_reference_bike.actions';
import { GET_REFERENCE_BIKE_REQUEST } from '../constants/get_reference_bike.constants';

function* getReferenceBikeRequest({ model_id, year, mileage }) {
    const { result, options, error } = yield call(checkReferenceBike, model_id, year, mileage);

    result
        ? yield put(getReferenceBikeRequestSuccess(options))
        : yield put(getReferenceBikeRequestFailure(error));
}

export default function* getReferenceBikeSaga() {
    yield takeEvery(GET_REFERENCE_BIKE_REQUEST, getReferenceBikeRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_reference_bike.saga.js